'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useUserContext } from '../../components/providers/user-context';
import { postProfilePicture } from '../data/post-profile-picture';
export const useProfilePictureUploadMutation = () => {
  const $ = _c(6);
  const {
    accessToken,
    personId
  } = useUserContext();
  const abortControllerRef = useRef(null);
  let t0;
  if ($[0] !== accessToken || $[1] !== personId) {
    t0 = async formData => {
      const abortController = new AbortController();
      abortControllerRef.current = abortController;
      return await postProfilePicture({
        abortSignal: abortController.signal,
        accessToken,
        formData,
        personId
      });
    };
    $[0] = accessToken;
    $[1] = personId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const mutate = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => abortControllerRef.current?.abort("Request canceled by user");
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== mutate) {
    t2 = {
      cancel: t1,
      mutate
    };
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};